<template>
  <footer class="app-footer">
    <div class="footer-container">
      <!-- Left: Social Media Icons -->
      <div class="footer-social">
        <a href="https://www.linkedin.com/company/360-degree-collective" target="_blank" class="social-icon" aria-label="LinkedIn">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
            <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z"/>
          </svg>
        </a>
        <a href="https://www.instagram.com/360degreecollective" target="_blank" class="social-icon" aria-label="Instagram">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
            <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
          </svg>
        </a>
        <a href="https://www.facebook.com/profile.php?id=61554432357425" target="_blank" class="social-icon" aria-label="Facebook">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
            <path d="M9 8h-3v4h3v12h5v-12h3.642l.358-4h-4v-1.667c0-.955.192-1.333 1.115-1.333h2.885v-5h-3.808c-3.596 0-5.192 1.583-5.192 4.615v3.385z"/>
          </svg>
        </a>
        
      </div>
      
      <!-- Center: Contact -->
      <div class="footer-contact">
        <a href="mailto:contact@360-degree-collective.com">contact@360-degree-collective.com</a>
      </div>
      
      <!-- Right: Phone Numbers (moved from footer-contact) -->
      <div class="footer-phone">
        <a href="tel:+13102860977">US: +1 310 286 0977</a>
        <a href="tel:+491714158769">EU: +49 171 4158769</a>
      </div>
    </div>
    
    <div class="footer-bottom">
      <div class="footer-bottom-content">
        <!-- Moved Pages/Privacy Links to top -->
        <div class="footer-pages">
          <router-link to="/privacy-policy" exact>Privacy Policy</router-link>
          <router-link to="/cookie-policy" exact>Cookie Policy</router-link>
          <button 
            type="button" 
            data-cc="show-preferencesModal"
            class="cookie-preferences-link"
          >
            Cookie Preferences
          </button>
          <router-link to="/terms-and-conditions-of-use" exact>Terms and Conditions of Use</router-link>
        </div>
        
        <!-- Copyright in middle -->
        <div class="copyright">
          <p>&copy; {{ currentYear }} by 360 Degree Collective Inc. | All rights reserved.</p>
        </div>
        
        <!-- Made with love at bottom -->
        <div class="made-with-love">
          <p>This site was crafted with ❤️ and ☕ in Munich.</p>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'AppFooter',
  computed: {
    currentYear() {
      return new Date().getFullYear();
    }
  }
}
</script>

<style scoped>
.app-footer {
  background-color: var(--cream);
  padding: 3rem 5vw 3rem;
  color: var(--black);
  font-family: 'Avenir', 'Arial', sans-serif;
}

.footer-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2rem;
}

.footer-social {
  display: flex;
  gap: 1rem;
  flex: 1;
  justify-content: flex-start;
}

.social-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--black);
  opacity: 0.8;
  transition: opacity 0.3s;
}

.social-icon:hover {
  opacity: 1;
  color: var(--accent);
  transform: scale(1.17);
}

.footer-contact {
  text-align: center;
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.footer-contact a {
  font-size: 1.1rem;
  transition: opacity 0.3s;
  opacity: 0.8;
  color: var(--black);
  display: inline-block;
  position: relative;
}

.footer-phone {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 0.3rem;
  align-items: flex-end;
}

.footer-phone a {
  font-size: 1rem;
  transition: opacity 0.3s;
  opacity: 0.8;
  color: var(--black);
}

.footer-contact a:hover, .footer-phone a:hover {
  opacity: 1;
  color: var(--accent);
}

.footer-bottom {
  padding-top: 2rem;
  border-top: 1px solid rgba(0,0,0,0.1);
  font-size: 0.8rem;
  font-family: 'Avenir', 'Arial', sans-serif;
}

.footer-bottom-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  width: 100%;
  gap: 1.2rem;
}

.footer-pages {
  display: flex;
  flex-direction: row;
  gap: 1.5rem;
  align-items: center;
  justify-content: center;
  margin-bottom: 0.8rem;
}

.footer-pages a,
.footer-pages .cookie-preferences-link {
  font-size: 0.7rem;
  opacity: 0.63;
  transition: opacity 0.3s;
  color: var(--black);
}

.footer-pages a:hover,
.footer-pages .cookie-preferences-link:hover {
  opacity: 1;
  color: var(--accent);
}

.cookie-preferences-link {
  background: none;
  border: none;
  cursor: pointer;
  font-family: inherit;
  text-decoration: none;
  padding: 0;
}

.copyright {
  margin: 0.8rem 0;
  opacity: 1;
}

.made-with-love {
  margin-top: 0.8rem;
  opacity: 1;
  font-size: 0.5rem;
}

.made-with-love p {
  font-size: 0.6rem !important;
}

.footer-bottom p {
  font-family: 'Avenir', 'Arial', sans-serif;
  font-size: 0.8rem;
  line-height: 1.2;
  margin: 0;
}

@media (max-width: 768px) {
  .footer-container {
    flex-direction: column;
    gap: 2rem;
  }
  
  .footer-social {
    order: 1;
  }
  
  .footer-contact {
    order: 0;
  }
  
  .footer-phone {
    order: 2;
    align-items: center;
  }
  
  .footer-pages {
    flex-wrap: wrap;
    gap: 1rem;
  }
}

@media (max-width: 480px) {
  .footer-pages {
    flex-direction: column;
    gap: 0.8rem;
  }
}
</style> 